import Flyer_layout_split_three_corners_034LayoutModel from 'src/models/layouts/flyer_layout_split_three_corners_034.layout.model'
import Flyer_layout_split_ellipse_036LayoutModel from 'src/models/layouts/flyer_layout_split_ellipse_036.layout.model'
import Flyer_layout_center_boxed_laurel_037LayoutModel from 'src/models/layouts/flyer_layout_center_boxed_laurel_037.layout.model'
import Flyer_layout_split_burst_026LayoutModel from 'src/models/layouts/flyer_layout_split_burst_026.layout.model'
import Flyer_layout_split_diagonal_lines_027LayoutModel from 'src/models/layouts/flyer_layout_split_diagonal_lines_027.layout.model'
import Flyer_layout_bottom_flourish_border_029LayoutModel from 'src/models/layouts/flyer_layout_bottom_flourish_border_029.layout.model'
import Flyer_layout_split_sketch_border_003LayoutModel from 'src/models/layouts/flyer_layout_split_sketch_border_003.layout.model'
import Flyer_layout_center_thin_lines_007LayoutModel from 'src/models/layouts/flyer_layout_center_thin_lines_007.layout.model'
import Flyer_layout_bottom_polaroid_013LayoutModel from 'src/models/layouts/flyer_layout_bottom_polaroid_013.layout.model'
import Flyer_layout_bottom_right_aligned_004LayoutModel from 'src/models/layouts/flyer_layout_bottom_right_aligned_004.layout.model'
import Flyer_layout_bottom_split_alignment_008LayoutModel from 'src/models/layouts/flyer_layout_bottom_split_alignment_008.layout.model'
import Flyer_layout_column_left_arrows_023LayoutModel from 'src/models/layouts/flyer_layout_column_left_arrows_023.layout.model'
import Flyer_layout_right_aligned_column_015LayoutModel from 'src/models/layouts/flyer_layout_right_aligned_column_015.layout.model'
import Flyer_layout_left_aligned_boxed_53LayoutModel from 'src/models/layouts/flyer_layout_left_aligned_boxed_53.layout.model'
import Flyer_layout_bottom_left_040LayoutModel from 'src/models/layouts/flyer_layout_bottom_left_040.layout.model'
import Flyer_layout_split_t_039LayoutModel from 'src/models/layouts/flyer_layout_split_t_039.layout.model'
import Flyer_layout_split_left_right_aligned_019LayoutModel from 'src/models/layouts/flyer_layout_split_left_right_aligned_019.layout.model'
import Flyer_layout_center_hexagon_012LayoutModel from 'src/models/layouts/flyer_layout_center_hexagon_012.layout.model'
import Flyer_layout_split_left_right_aligned_two_044LayoutModel from 'src/models/layouts/flyer_layout_split_left_right_aligned_two_044.layout.model'
import Flyer_layout_centered_date_top_location_bottom_020LayoutModel from 'src/models/layouts/flyer_layout_centered_date_top_location_bottom_020.layout.model'
import Flyer_layout_card_circle_041LayoutModel from 'src/models/layouts/flyer_layout_card_circle_041.layout.model'
import Flyer_layout_bottom_middle_aligned_011LayoutModel from 'src/models/layouts/flyer_layout_bottom_middle_aligned_011.layout.model'
import Flyer_layout_center_swash_038LayoutModel from 'src/models/layouts/flyer_layout_center_swash_038.layout.model'
import Flyer_layout_centered_48LayoutModel from 'src/models/layouts/flyer_layout_centered_48.layout.model'
import Flyer_layout_bottom_dashed_line_017LayoutModel from 'src/models/layouts/flyer_layout_bottom_dashed_line_017.layout.model'

export const flyerDesignLayoutConfig = [
  {
    slug: 'flyer_layout_left_aligned_boxed_53',
    layout: Flyer_layout_left_aligned_boxed_53LayoutModel,
    designIds: [120]
  },
  {
    slug: 'flyer_layout_right_aligned_column_015',
    layout: Flyer_layout_right_aligned_column_015LayoutModel,
    designIds: [17]
  },
  {
    slug: 'flyer_layout_column_left_arrows_023',
    layout: Flyer_layout_column_left_arrows_023LayoutModel,
    designIds: [34]
  },
  {
    slug: 'flyer_layout_bottom_split_alignment_008',
    layout: Flyer_layout_bottom_split_alignment_008LayoutModel,
    designIds: [9]
  },
  {
    slug: 'flyer_layout_split_three_corners_034',
    layout: Flyer_layout_split_three_corners_034LayoutModel,
    designIds: [71, 137, 144, 147, 151]
  },
  {
    slug: 'flyer_layout_split_ellipse_036',
    layout: Flyer_layout_split_ellipse_036LayoutModel,
    designIds: [75, 139, 146, 149]
  },
  {
    slug: 'flyer_layout_center_boxed_laurel_037',
    layout: Flyer_layout_center_boxed_laurel_037LayoutModel,
    designIds: [72, 138, 152]
  },
  {
    slug: 'flyer_layout_split_burst_026',
    layout: Flyer_layout_split_burst_026LayoutModel,
    designIds: [53, 135, 106]
  },
  {
    slug: 'flyer_layout_split_diagonal_lines_027',
    layout: Flyer_layout_split_diagonal_lines_027LayoutModel,
    designIds: [54, 136, 143, 148]
  },
  {
    slug: 'flyer_layout_bottom_flourish_border_029',
    layout: Flyer_layout_bottom_flourish_border_029LayoutModel,
    designIds: [51, 134, 141, 150, 154]
  },
  {
    slug: 'flyer_layout_split_sketch_border_003',
    layout: Flyer_layout_split_sketch_border_003LayoutModel,
    designIds: [3, 130]
  },
  {
    slug: 'flyer_layout_center_thin_lines_007',
    layout: Flyer_layout_center_thin_lines_007LayoutModel,
    designIds: [47, 133, 140, 153]
  },
  {
    slug: 'flyer_layout_bottom_polaroid_013',
    layout: Flyer_layout_bottom_polaroid_013LayoutModel,
    designIds: [15, 132, 145]
  },
  {
    slug: 'flyer_layout_bottom_right_aligned_004',
    layout: Flyer_layout_bottom_right_aligned_004LayoutModel,
    designIds: [4, 131, 142]
  },
  {
    slug: 'flyer_layout_split_t_039',
    layout: Flyer_layout_split_t_039LayoutModel,
    designIds: [77]
  },
  {
    slug: 'flyer_layout_bottom_left_040',
    layout: Flyer_layout_bottom_left_040LayoutModel,
    designIds: [78]
  },
  {
    slug: 'flyer_layout_split_left_right_aligned_019',
    layout: Flyer_layout_split_left_right_aligned_019LayoutModel,
    designIds: [96]
  },
  {
    slug: 'flyer_layout_center_hexagon_012',
    layout: Flyer_layout_center_hexagon_012LayoutModel,
    designIds: [103]
  },
  {
    slug: 'flyer_layout_split_left_right_aligned_two_044',
    layout: Flyer_layout_split_left_right_aligned_two_044LayoutModel,
    designIds: [82]
  },
  {
    slug: 'flyer_layout_centered_date_top_location_bottom_020',
    layout: Flyer_layout_centered_date_top_location_bottom_020LayoutModel,
    designIds: [105]
  },
  {
    slug: 'flyer_layout_card_circle_041',
    layout: Flyer_layout_card_circle_041LayoutModel,
    designIds: [79]
  },
  {
    slug: 'flyer_layout_bottom_middle_aligned_011',
    layout: Flyer_layout_bottom_middle_aligned_011LayoutModel,
    designIds: [86]
  },
  {
    slug: 'flyer_layout_center_swash_038',
    layout: Flyer_layout_center_swash_038LayoutModel,
    designIds: [108]
  },
  {
    slug: 'flyer_layout_centered_48',
    layout: Flyer_layout_centered_48LayoutModel,
    designIds: [87]
  },
  {
    slug: 'flyer_layout_bottom_dashed_line_017',
    layout: Flyer_layout_bottom_dashed_line_017LayoutModel,
    designIds: [98]
  },
  {
    slug: 'custom',
    layout: null,
    designIds: [8]
  }
]
